import AlertFrame from "./AlertFrame";

export default AlertFrame;